<template>
  <vx-card class="campaign-summary" :noShadow="true">
    <div v-for="(adset, index) in data.adsets" :key="'adset-summary-' + index">
      <div class="vs-row header-divider">
        <vs-divider v-if="index == 0" />

        <p class="font-bold mb-3 custom-type-style">
          {{ $t('Ad Set') }} {{ index + 1 }}:
        </p>
        <p class="mb-3 custom-type-style">
          {{ adset.name }}
        </p>

        <div v-if="adset.pageViewsEstimation">
          <p class="mb-3 custom-type-style traffic-summary-label">
            {{ $t('Traffic estimation') }}
          </p>
          <p class="font-bold mb-3 custom-type-style traffic-summary-value">
            {{ valueTxt(adset.pageViewsEstimation) }}
          </p>
        </div>
      </div>

      <!-- <vs-divider class="custom-divider-style" v-if="adset.new_audience_name" />

      <div class="vs-row" v-if="adset.new_audience_name">
        <p class="font-bold mb-3 custom-type-style">
          {{ $t('Audinece') }} {{ index + 1 }}:
        </p>
        <p class="mb-3 custom-type-style">
          {{ adset.new_audience_name }}
        </p>
      </div> -->

      <vs-divider v-if="index + 1 != data.adsets.length" class="custom-divider-style" />
    </div>

    <div class="vs-row mt-4 custom-summary-button-style" v-if="!editing">
      <vs-button id="create-campaign-summary-s3-button" color="primary" type="filled" class="w-full text-sm block m-auto rounded-sm" @click="goToStep()">
        {{ $t('Ad Set Targeting') }}
      </vs-button>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    goToStep () {
      const wizard = this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.campaignWizard

      wizard.navigateToTab(2)
    },
    valueTxt (pageViewsEstimation) {
      if (!pageViewsEstimation) {
        return '0'
      }

      return String(pageViewsEstimation).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
  .traffic-summary-label {
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 21px !important;
    color: rgba(0, 0, 0, 0.56) !important;
  }

  .traffic-summary-value {
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    color: #2C2C2C !important;
  }
</style>
